/* v8 ignore start -- @preserve */
export const coreCurrencies = [
  "ARS",
  "AUD",
  "BGN",
  "BRL",
  "CAD",
  "CHF",
  "CNY",
  "CZK",
  "DKK",
  "EUR",
  "GBP",
  "GBX",
  "HKD",
  "HRK",
  "HUF",
  "IDR",
  "INR",
  "ISK",
  "JPY",
  "KRW",
  "MXN",
  "NOK",
  "NZD",
  "PLN",
  "RSD",
  "RUB",
  "SAR",
  "SEK",
  "SGD",
  "TRY",
  "USD",
  "ZAR",
] as const;

export type CoreCurrency = (typeof coreCurrencies)[number];

export type CoreMoney = {
  /**
   * @type number
   */
  amount: number;
  /**
   * @type string
   */
  currency: CoreCurrency;
};
